import { render } from "./HomeCheckin.vue?vue&type=template&id=8c80a1f0"
import script from "./HomeCheckin.vue?vue&type=script&lang=js"
export * from "./HomeCheckin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__